/* unplugin-vue-components disabled */import script from "./PcMenuManage.vue?vue&type=script&setup=true&lang=js"
export * from "./PcMenuManage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__